// extracted by mini-css-extract-plugin
export default {"container":"Input_container__yOzss","warning":"Input_warning__RW-0L","input":"Input_input__vCVdL","label":"Input_label__ZxYhU"};